import { useState, useEffect, Ref } from 'react';

import { Input } from '@revenuemarket/cds';
import { InputRef } from 'antd';

interface InputProps {
  onSave: (nameInput: string) => void;
  inputRef?: Ref<InputRef>;
  name: string;
  isLoading?: boolean;
}

export const NAME_MAX_LENGTH_INFO = '20자 까지만 입력할 수 있어요.';
export const NAME_MAX_LENGTH = 20;

const NameInput: React.FC<InputProps> = ({ name, isLoading, onSave, inputRef }) => {
  const [nameInput, setNameInput] = useState<string>(name);

  const onSaveInput = async () => {
    // 변경되지않았으면 저장 안함
    if (nameInput === name) {
      return;
    }
    if (nameInput.length === 0 || nameInput.length > NAME_MAX_LENGTH) {
      setNameInput(name);
      return;
    }

    onSave(nameInput);
  };

  const getInputType = () => {
    if (nameInput?.length > NAME_MAX_LENGTH) {
      return 'warning';
    }
    if (nameInput?.length === 0) {
      return 'error';
    }
  };
  const getAdditionalText = () => {
    if (nameInput?.length > NAME_MAX_LENGTH) {
      return NAME_MAX_LENGTH_INFO;
    }
    if (nameInput?.length === 0) {
      return '계정 이름을 입력해주세요.';
    }
  };

  useEffect(() => {
    setNameInput(name);
  }, [name]);

  return (
    <Input
      ref={inputRef}
      style={{ width: '100%' }}
      value={nameInput}
      onChange={(e) => setNameInput(e.target.value)}
      onBlur={() => onSaveInput()}
      inputStatus={isLoading ? 'loading' : getInputType()}
      disabled={isLoading}
      additionalText={getAdditionalText()}
    />
  );
};

export default NameInput;
